const customRoutes = {
  gameProject: "/project/game",
  jamProject: "/project/jam",
  webProject: "/project/web",
  allProject: "/project/all",
  resume: "/resume",
};

export default customRoutes;
